import React, {memo} from 'react';

import {Document} from '@react-pdf/renderer';

import {IntlShape} from 'react-intl';
import BaselinePDFHeader from './BaselinePDFHeader';
import BaselinePDFMeta from './BaselinePDFMeta';
import BaselinePDFPhase from './BaselinePDFPhase';
import BaselinePDFSummary from './BaselinePDFSummary';
import {BaselinePDFClientType, BaselinePDFPhaseType, BaselinePDFProjectType} from './BaselinePDFTypes';
import {PageStandard, TextAuxiliary, ViewRow} from './layout/PDFLayout';

type BaselinePDFProps = {
	project: BaselinePDFProjectType;
	phases?: BaselinePDFPhaseType[];
	client?: BaselinePDFClientType;
	creatorName: string;
	companyName: string;
	date: string;
	intl: IntlShape;
};

const BaselinePDF = memo(({client, project, phases, creatorName, companyName, date, intl}: BaselinePDFProps): JSX.Element => {
	return (
		<Document>
			<PageStandard>
				{companyName ? (
					<ViewRow fixed>
						<TextAuxiliary>{companyName}</TextAuxiliary>
					</ViewRow>
				) : null}
				<BaselinePDFHeader project={project} />
				<BaselinePDFMeta client={client} creatorName={creatorName} date={date} intl={intl} />
				<BaselinePDFSummary phases={phases} projectTotal={project.total} intl={intl} />
				{phases
					? phases
							.filter(phase => phase.items.length > 0)
							.map(phase => {
								return (
									<BaselinePDFPhase
										key={phase.id}
										phase={phase}
										intl={intl}
										minutesPerDay={project.minutesPerDay}
									/>
								);
							})
					: null}
			</PageStandard>
		</Document>
	);
});

export default BaselinePDF;
